import { Inject } from '@angular/core';
import { Component, AfterViewChecked, OnInit, ChangeDetectorRef } from '@angular/core';
import { HomeService } from 'src/services/home/home.service';
import { AESEncrypt } from 'src/app/common/Helper/AESEncryp';
import { WebStorageService, LOCAL_STORAGE } from 'ngx-webstorage-service';
import { SweetServices } from 'src/services/sweet.services';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements AfterViewChecked, OnInit {
  title = 'Armor AML';
  loading = false;
  mostrarPopup = false;
  selectedFile: File | null = null;
  licenseKey: string = '';
  errorMessage: string = '';
  aes = new AESEncrypt();

  constructor(
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
    private cdRef: ChangeDetectorRef,
    private alerta: SweetServices,
    private homeService: HomeService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.validarLicencia();
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  async validarLicencia() {
    try{

      const response = await firstValueFrom(this.homeService.buscarAplicacion());

      if (
        response.isCorrect === 'true' &&
        response.data.info.result.isValid
      ) {
        const encrypted = this.aes.encryptModel(response.data.info.result);
        await this.storage.set('environment', encrypted);
      } else {
        await this.storage.remove('environment');
      }

      let appData = await this.homeService.getEnvironment();

      if (appData) {
        this.mostrarPopup = false;
      } else {
        this.alerta.AlertaError("Licencia no verificada");
        this.router.navigate(['/login']);
        this.mostrarPopup = true;
      }
    }catch{
      this.alerta.AlertaError("Licencia no verificada");
      this.router.navigate(['/login']);
      this.storage.remove('environment');
      this.mostrarPopup = true;
    }
  }

  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (!file) return;
    this.selectedFile = file;
  }

  seleccionarArchivo() {
    if (!this.selectedFile) {
      this.alerta.AlertaError('Debe seleccionar un archivo primero');
    } else {
      this.alerta.AlertaSuccess(`Archivo listo: ${this.selectedFile.name}`);
    }
  }

  enviarLicencia() {
    if (!this.selectedFile || !this.licenseKey) {
      this.errorMessage = 'Debe seleccionar archivo e ingresar la key';
      return;
    }
    this.errorMessage = '';

    const formData = new FormData();
    formData.append('license', this.selectedFile);
    formData.append('key', this.licenseKey);

    this.homeService.uploadLicense(formData).subscribe({
      next: (response) => {
        if (response?.isCorrect === 'true') {
          this.mostrarPopup = false;
          this.validarLicencia();
        } else {
          this.alerta.AlertaError(response?.message || 'Error al guardar licencia');
        }
      },
      error: () => {
        this.alerta.AlertaError('Error al enviar licencia');
      }
    });
  }
}
